import Hero from "@/sections/Hero";
import EditorialMarquee from "@/sections/EditorialMarquee";
import About from "@/sections/About";
import Services from "@/sections/Services";
import WhyChooseUs from "@/sections/WhyChooseUs";
import Portfolio from "@/sections/Portfolio";
import Process from "@/sections/Process";
import Pricing from "@/sections/Pricing";
import FAQ from "@/sections/FAQ";
import Newsletter from "@/sections/Newsletter";
import Contact from "@/sections/Contact";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <EditorialMarquee />
      <About />
      <Services />
      <WhyChooseUs />
      <Portfolio />
      <Process />
      <Pricing />
      <FAQ />
      <Newsletter />
      <Contact />
    </main>
  );
}
